(() => {
  'use strict';
  const VERSION = '2026-08-17-remove-socials-v31';
  const SECTION = '.faire-dawn-header-section';
  if (window.__ddUiV31 === VERSION) return;
  window.__ddUiV31 = VERSION;

  function purge(section) {
    if (!(section instanceof Element)) return;
    section.querySelectorAll('.dd-mobile-social-dock, .ddmm22__social, .ddmm27__social').forEach(node => node.remove());
  }

  let raf = 0;
  function queue() {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = 0;
      document.querySelectorAll(SECTION).forEach(purge);
    });
  }

  function start() {
    queue();
    const observer = new MutationObserver(queue);
    document.querySelectorAll(SECTION).forEach(section => observer.observe(section, { childList:true, subtree:true }));
    document.addEventListener('shopify:section:load', queue);
    setTimeout(queue, 80);
    setTimeout(queue, 240);
    setTimeout(queue, 600);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', start, { once:true })
    : start();
})();
